var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/control/Clean
 */
import Control from './Control';
import MapControls from './MapControls';
import { i18n } from '../dictionary';
import VControlButton from '../view/VControlButton';
/**
 * @classdesc
 * Provides a button that clean up the painted elements on the map related to the API's own controls.
 * @extends {Control}
 * @api
 */
var Clean = /** @class */ (function (_super) {
    __extends(Clean, _super);
    /**
     * @constructor
     */
    function Clean() {
        var _this = this;
        var controlButton = new VControlButton('clean');
        var element = controlButton.getElement();
        _this = _super.call(this, {
            element: element,
            className: 'cercaliagl.control.Clean',
            name: MapControls.CLEAN,
        }) || this;
        /**
         * @private
         * @type {VControlButton}
         */
        _this.controlButton_ = controlButton;
        /**
         * @private
         * @type {HTMLElement}
         */
        _this.element_ = element;
        _this.initialize_();
        return _this;
    }
    /**
     * @private
     */
    Clean.prototype.initialize_ = function () {
        this.controlButton_.setTooltip(i18n('tooltipClean'));
        this.element_.addEventListener('click', this.handleClick_.bind(this));
    };
    /**
     * Force clean. Call handle click event function.
     * @api
     */
    Clean.prototype.clean = function () {
        this.handleClick_();
    };
    /**
     * @private
     */
    Clean.prototype.handleClick_ = function () {
        this.viewInterface_.closePopups();
        var addressControl = this.viewInterface_.getAddressControl();
        if (addressControl) {
            addressControl.clean();
        }
        var navbarControl = this.viewInterface_.getNavBarControl();
        if (navbarControl) {
            navbarControl.clear();
        }
        var map = this.getCercaliaMap();
        var mapDistance = map.getMapDistance();
        if (mapDistance) {
            mapDistance.clean();
        }
    };
    return Clean;
}(Control));
export default Clean;
//# sourceMappingURL=Clean.js.map